import getLocale from "./getLocale";

const locale = getLocale();

const formatCurrency = (value: string | undefined) => {
  if (!value) return "";

  const number = Number(value);
  return new Intl.NumberFormat(locale.code, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export default formatCurrency;
